// Define a set of types that should stay in the modern portal
const modernOnlyTypes = new Set(['accountsettings'])

export const isLegacyPage = (type: string): boolean => {
  // Determines whether the given type should navigate to the legacy portal
  if (modernOnlyTypes.has(type)) {
    // Stay in the modern portal
    return false
  }
  // Navigate to the legacy portal (If the rest of the conditions are met)
  return true
}
